import gsap from '../../../gsap-public/esm/index.js';

const log = (message, ...args) => {
  const timestamp = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit', fractionalSecondDigits: 3 });
  console.log(`[${timestamp}] ⏳ Preloader: ${message}`, ...args);
};

class Preloader {
  constructor() {
    this.element = document.getElementById('preloader');
    this.progressBar = this.element?.querySelector('.preloader__progress-bar');
  }

  async load(assets) {
    log('load() called, element exists:', !!this.element);
    if (!this.element) return;

    log('Assets to load:', assets.length);

    // If no assets, just show a brief animation
    if (assets.length === 0) {
      log('No assets, simulating loading');
      await this.simulateLoading();
      log('Simulation complete, hiding');
      await this.hide();
      log('Hidden');
      return;
    }

    const promises = assets.map((asset, i) => {
      return new Promise((resolve) => {
        // Simulate loading (replace with actual asset loading logic)
        setTimeout(() => {
          const progress = ((i + 1) / assets.length) * 100;
          this.updateProgress(progress);
          resolve();
        }, 300);
      });
    });

    await Promise.all(promises);
    await this.hide();
  }

  async simulateLoading() {
    return new Promise((resolve) => {
      gsap.to(this.progressBar, {
        scaleX: 1,
        duration: 0.8,
        ease: 'power2.inOut',
        onComplete: resolve
      });
    });
  }

  updateProgress(percent) {
    if (this.progressBar) {
      gsap.to(this.progressBar, {
        scaleX: percent / 100,
        duration: 0.3,
        ease: 'power2.out'
      });
    }
  }

  async hide() {
    return new Promise((resolve) => {
      const tl = gsap.timeline({
        onComplete: () => {
          if (this.element) {
            this.element.style.display = 'none';
          }
          resolve();
        }
      });

      tl.to(this.element, {
        opacity: 0,
        duration: 0.4,
        ease: 'power2.inOut',
        delay: 0.2
      });
    });
  }
}

export default Preloader;
